import PropTypes from 'prop-types'
import React from 'react'

import PhoneField from 'components/_form/PhoneField'
import Select from 'components/_form/Select'
import { RU } from 'constants/countries'
import { ResizeContext } from 'contexts/Resize'
import { phoneMaskEurope, phoneMaskRussian } from 'forms/masks'
import {
  composeValidators,
  errorCustom,
  minLength,
  required,
} from 'forms/validations'

import { Box, BoxCode, BoxPhone } from './styles'

const PhoneWithCode = ({
  texts,
  optionsPhoneCode,
  isDisabled,
  errorsDict,
  locale,
  alpha2Code,
  ...props
}) => {
  const { mobile, breakpoint } = React.useContext(ResizeContext)

  return (
    <Box {...props}>
      <BoxCode>
        <Select
          placeholder={texts.fields.code.title}
          name="phone_code"
          options={optionsPhoneCode}
          withEllipsis={false}
          isDisabled={isDisabled}
          isMobile={mobile || breakpoint === ''}
          validate={errorCustom(errorsDict.contact_details_required, required)}
        />
      </BoxCode>
      <BoxPhone>
        <PhoneField
          autoComplete="phone"
          placeholder={texts.fields.phone.title}
          isDisabled={isDisabled}
          type="tel"
          name="phone"
          phoneMask={locale === RU ? phoneMaskRussian : phoneMaskEurope}
          alpha2Code={alpha2Code}
          validate={composeValidators([
            errorCustom(errorsDict.contact_details_required, required),
            errorCustom(
              errorsDict.phone_min_length,
              minLength(locale === RU ? phoneMaskRussian.length : 5),
            ),
          ])}
        />
      </BoxPhone>
    </Box>
  )
}

PhoneWithCode.propTypes = {
  texts: PropTypes.object.isRequired,
  optionsPhoneCode: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  errorsDict: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  alpha2Code: PropTypes.string.isRequired,
}

export default PhoneWithCode
